import moment from 'moment';

import {colors} from 'shells/colors/colors';
import {RANKED_COLORS} from 'shells/maps/consts';

import type {CompetitorsPageTab} from './competitors-page-wrapper';

const CHANNELS = [
    'Direct',
    'Display Ads',
    'Email',
    'Organic',
    'Paid Search',
    'Referrals',
    'Social',
];

export const channelValues: any[] = CHANNELS.map((channel, index) => ({
    name: channel,
    // @ts-expect-error
    fill: colors[RANKED_COLORS[index]],
}));

export const sortBucketsAndAddStarAndFill = (
    data: {
        bucket: string;
        count: number;
        percent: number;
        segments: any[];
    }[],
    website?: string | null
): any[] => {
    return data
        .map((bucket) => ({
            ...bucket,
            star: bucket.bucket === website,
            invalid: bucket.count === 0,
        }))
        .sort((a, b) => {
            if (a.star) {
                return -1;
            } else if (b.star) {
                return 1;
            } else if (a.count > 0 && b.count > 0) {
                // sort by count if we have it
                return a.count < b.count ? 1 : -1;
            } else {
                // else sort by count of first segment (used in the traffic over time chart)
                return a.segments[0].count.value < b.segments[0].count.value ? 1 : -1;
            }
        })
        .map((bucket, index) => ({
            ...bucket,
            // @ts-expect-error
            fill: colors[RANKED_COLORS[index]],
        }));
};

// We aren't sure when last month's data is available, exactly,
// so we aren't trying to fetch it before the 16th
export const isAfterFifteenthOfMonth = moment().date() > 15;

export const getTab = (tab?: string | null): CompetitorsPageTab => {
    switch (tab) {
        case 'charts':
            return 'charts';
        case 'settings':
            return 'settings';
        case 'paid':
            return 'paid';
        case 'organic':
            return 'organic';
        default:
            return 'charts';
    }
};
